export const CUSTOMER_VOLUME_MIN = 1;
export const CUSTOMER_VOLUME_MAX = 10_000_000;

export type CustomerVolumeValidation = {
  customerVolume?: number;
  error?: string;
};

export function formatCustomerVolumeInput(value: string): string {
  const digits = value.replaceAll(',', '');
  if (!/^\d+$/.test(digits)) return value;
  return Number(digits).toLocaleString('en-US');
}

export function validateCustomerVolumeInput(value: string | undefined): CustomerVolumeValidation {
  if (value === undefined) return {};
  const normalized = value.replaceAll(',', '');
  if (!/^\d+$/.test(normalized)) {
    return { error: 'Enter a whole number from 1 to 10,000,000.' };
  }
  const customerVolume = Number(normalized);
  if (customerVolume < CUSTOMER_VOLUME_MIN || customerVolume > CUSTOMER_VOLUME_MAX) {
    return { error: 'Enter a whole number from 1 to 10,000,000.' };
  }
  return { customerVolume };
}
